const blogPage = (WpTag) => `
  title
  subtitlePageName
  filterPopularTitle
  filterCategoriesTitle
`;

module.exports.blogPage = blogPage;
